function ModalMembroEquipe() {
  const selectTipoUsuario = $('#tipoUsuario');

  $(document).ready(function () {
    defineRuleRequired(selectTipoUsuario.val(),)
  });

  selectTipoUsuario.on('change', function() {
    defineRuleRequired($(this).val());
  });
}

function defineRuleRequired(tipoUsuario) {
  const cpfOrCnpjInput = $('#cpfOrCnpj');
  const fone1Input = $('#fone1');
  const isAdministrador = Boolean(tipoUsuario === 'ADMINISTRADOR');

  if (window.location.pathname === '/settings/membros-de-equipe') {
    cpfOrCnpjInput.attr('data-rule-required', isAdministrador);
    fone1Input.attr('data-rule-required', isAdministrador);
  }

  defineMessageRequired(cpfOrCnpjInput, isAdministrador);
  defineMessageRequired(fone1Input, isAdministrador);
}

function defineMessageRequired (input, isAdministrador) {
  const spanEl = input.parent().find('span');

  if (isAdministrador) {
    spanEl.text(input.attr('data-msg-common-required'));
  } else {
    spanEl.text('');
  }
}

module.exports = {
  init: ModalMembroEquipe,
  url: /^\/settings\/membros-de-equipe/
};

